import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { DetalleCargaLiquid } from 'src/app/Models/detcargaliq/detalle-carga-liquid';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ALertOption } from 'src/app/Models/alert/alert-option';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { InfoComponent } from '../objects/info/info/info.component';
import { LoadingComponent } from '../objects/loading/loading.component';
import { Gastos } from 'src/app/Models/gastos/gastos';
import * as moment from 'moment';
import { Personal } from 'src/app/Models/personal/personal';

@Component({
  selector: 'app-gastos',
  templateUrl: './gastos.component.html',
  styleUrls: ['./gastos.component.css']
})
export class GastosComponent implements OnInit {
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  public usuario: any;
  public gasto: Gastos = new Gastos();
  public alertType: AlertType = new AlertType();
  public options: ALertOption = new ALertOption();
  public index: number = 0;
  public numitem: number = 0;
  public tiposgastos: any[] = [];
  public listapersonal: Personal[] = [];
  public pagarticulo: any;
  constructor(private title: Title, private data: DataService, private notify: NotifyService, private auth: AuthService, private route: Router) { }

  ngOnInit() {
    this.title.setTitle('Gastos | Sistema de ventas');
    this.usuario = this.auth.getCurrentUser();
    this.gasto.idvende = this.usuario.idpersonal.idpersonal;
    this.gasto.fecha = moment(new Date()).format('YYYY-MM-DD')
    this.gasto.hora = moment(new Date()).format('HH:mm:ss')
    this.gasto.estado = "emitido";
    this.gasto.idtipogasto = 1;
    console.log("Usuario",this.usuario);
    console.log(this.usuario.idpersonal.idpersonal);
    console.log(this.usuario.idpersonal.idnivel);

    this.getTiposGastos();
    this.getPersonal();
    if (this.usuario.idpersonal.idnivel != 1) {
      console.log("Buscando liq");
      
      this.getliquidacion();
    }else{
      this.gasto.idliquida = null
    }

  }

  getPersonal(){
    this.data.GetSimple(this.data.api.personal).subscribe((r) => {
      this.listapersonal = r
    })
  }
  
  getTiposGastos() {
    this.data.GetSimple(this.data.api.tiposgastos).subscribe(r => {
      this.tiposgastos = r
      console.log(r)
    })
  }

  getliquidacion() {
    const datapersonal = { 'fecha': this.gasto.fecha, 'idpersonal': this.gasto.idvende }
    console.log(datapersonal);

    this.data.Post('getLiqGasto', datapersonal).subscribe((data) => {
      // Manejar la respuesta exitosa
      console.log("Liquidacion con ID: ",data.idliquida);
      
      this.gasto.idliquida = data.idliquida
      console.log('Liquidación obtenida:', data);
    },
      (error) => {
        // Manejar el error de obtener la liquidación
        console.error('Error al obtener la liquidación:', error);
        // Si no se puede obtener la liquidación, cerrar sesión y redirigir a la página de inicio de sesión
        this.usuario.idpersonal.idnivel!=2?this.data.notify("Se necesita crear una liquidacion.", "Liquidacion no encontrada.", this.data.alertType.info):this.auth.logoutUser()
      }
    );
  }




  Guardargasto() {
    console.log(this.gasto);
    if (!this.gasto.idliquida && this.usuario.idpersonal.idnivel != 1) {
      console.log(this.usuario);
      
      return this.data.notify("Se necesita una liquidacion para guardar el gasto.", "Liquidacion no encontrada.", this.data.alertType.info)
    }
    this.data.Post(this.data.api.gasto, this.gasto).subscribe((data) => {
      // Manejar la respuesta exitosa
      console.log('Gasto guardado:', data);
      this.data.notify("Operacion exitosa", "Exito", this.data.alertType.success)
      this.gasto.concepto = ""
      this.gasto.total = 0;

    },
      (error) => {
        // Manejar el error de obtener la liquidación
        console.error('Error al obtener la liquidación:', error);
        this.data.notify("Operacion fallida", "Error", this.data.alertType.error)
      }
    );

  }
}
